import { Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const EngagementModel = ({ data }) => {

    const navigate = useNavigate()

    return (
        <div >
            <div className='max-w-screen-2xl mx-auto py-5 md:py-8 px-6 md:px-12'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                    <div>
                        <h1
                            className='text-xl dark:text-white md:text-2xl font-bold text-center md:text-left'
                        >
                            {data.title1}
                        </h1>
                        <h1
                            className='text-xl md:text-2xl font-bold text-center md:text-left text-red-500'
                        >
                            {data.title2}
                        </h1>
                        <div className=' my-2'>
                            <p className='text-center md:text-left text-xs  dark:text-white'>
                                {data.desc}
                            </p>
                        </div>
                        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mt-7 gap-4'>
                            {data.tags.map((item, i) => (
                                <div key={i}
                                    onClick={() => navigate('/pricing')}
                                    className='bg-white dark:bg-slate-700 cursor-pointer rounded-lg shadow-md flex items-center hover:scale-90 duration-1000 justify-center border-t-2 border-red-500'>
                                    <h1 className='font-bold text-xs py-4 px-2 text-center dark:text-white'>
                                        {item}
                                    </h1>
                                </div>
                            ))}
                        </div>
                        <div className='my-11 flex justify-center md:justify-start'>

                            <Button
                                onClick={() => navigate('/pricing')}
                                variant='contained' color='error'
                                className='blob-btn'
                                size='large'
                                sx={{
                                    borderRadius: '30px',
                                    fontSize: '16px',
                                    backgroundColor: 'black !important',
                                    textTransform: 'none'
                                }}
                            >
                                Explore the pricing
                                <span class="blob-btn__inner">
                                    <span class="blob-btn__blobs">
                                        <span class="blob-btn__blob"></span>
                                        <span class="blob-btn__blob"></span>
                                        <span class="blob-btn__blob"></span>
                                        <span class="blob-btn__blob"></span>
                                    </span>
                                </span>

                            </Button>
                        </div>
                    </div>
                    <div className='w-[80%] mx-auto md:w-full'>
                        <div className='flex items-center justify-center'>
                            <img src={data.img} alt="img" className='object-contain cursor-pointer'
                                onClick={() => window.scrollTo(0, 0)}

                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default EngagementModel